import {ActiveTableTreeConfig} from '@/components/Ui/ActiveTableTree/core/ActiveTableTree'
import store from '@/store/index'
import router from '@/routes'
import WikiNode from '@/models/wiki/wikiNode'
import WikiPage from '@/models/wiki/wikiPage'
import _ from 'lodash'

import titleComponent from '@/components/wiki/tree/title.vue'
import detailButtonComponent from '@/components/wiki/tree/detailButton.vue'

// @ts-ignore
import messages from '@/lang/index'

const WikiListTreeTableConfig: ActiveTableTreeConfig = {
  name: messages.wiki.node_list,
  tree: {
    cols: {
      title: {
        label: messages.labels.name,
        component: titleComponent
      }
    },
    treeProps: {
      label: 'title',
      isLeaf: 'leaf'
    },
    async lazyMethod (node: {data: WikiNode, level: number}, resolve: (nodes: WikiPage[] | WikiNode[]) => any[]) {
      if (Array.isArray(node.data)) return [];
      let pages = await store.dispatch('wiki/pageList', node.data.getId())
      let children = node.data.getChildren()
      return resolve(_.concat(pages, children));
    }
  },
  onNodeClick (event: WikiNode | WikiPage) {
    if (!event.isNode) {
      router.push({name: 'wikiPage', params: {id: event.getId()}})
    }
  }
}
export default WikiListTreeTableConfig
